import React from 'react';
import { useTranslation } from 'react-i18next';

function Card({ title, desc, href }) {
  return (
    <a
      href={href}
      className="block border rounded shadow-sm hover:shadow-md transition p-4"
    >
      <div className="font-semibold">{title}</div>
      <div className="text-sm text-gray-600 mt-1">{desc}</div>
      <div className="text-blue-700 text-sm mt-2 underline">{'Read →'}</div>
    </a>
  );
}

export default function Guides() {
  const { t } = useTranslation();

  const guides = [
    {
      key: 'invite',
      title: t('guides.cards.invite.title'),
      desc: t('guides.cards.invite.desc'),
      href: '/faq#invite-admins', // or create dedicated guide routes later
    },
    {
      key: 'editor',
      title: t('guides.cards.editor.title'),
      desc: t('guides.cards.editor.desc'),
      href: '/faq#add-content',
    },
    {
      key: 'files',
      title: t('guides.cards.files.title'),
      desc: t('guides.cards.files.desc'),
      href: '/faq#files',
    },
    {
      key: 'cookies',
      title: t('guides.cards.cookies.title'),
      desc: t('guides.cards.cookies.desc'),
      href: '/cookie-settings',
    },
  ];

  return (
    <div className="max-w-5xl mx-auto bg-white border rounded shadow p-6 md:p-8">
      <h1 className="text-3xl font-bold mb-2">{t('guides.title')}</h1>
      <p className="text-sm text-gray-500 mb-8">{t('guides.subtitle')}</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {guides.map(g => (
          <Card key={g.key} title={g.title} desc={g.desc} href={g.href} />
        ))}
      </div>

      <p className="text-sm text-gray-600 mt-6">
        {t('guides.moreHelp')}{' '}
        <a className="text-blue-700 underline" href="mailto:info@vbwebb.se">info@vbwebb.se</a>.
      </p>
    </div>
  );
}
